export const GETALLPINCODES_SUCCESS = "GETALLPINCODES_SUCCESS";
export const GETALLPINCODES_ERROR = "GETALLPINCODES_ERROR";

export const ADDPINCODE_SUCCESS = "ADDPINCODE_SUCCESS";
export const ADDPINCODE_ERROR = "ADDPINCODE_ERROR";

export const CHANGE_PINCODE_ACTION_SUCCESS = "CHANGE_PINCODE_ACTION_SUCCESS";
export const CHANGE_PINCODE_ACTION_ERROR = "CHANGE_PINCODE_ACTION_ERROR";

export const UPDATEPINCODE_SUCCESS = "UPDATEPINCODE_SUCCESS";
export const UPDATEPINCODE_ERROR = "UPDATEPINCODE_ERROR";